import config from '../config/config';
import cookies from 'react-cookies';

export let sessionCheck = false;
export default function checkSession() {
  const accessToken = cookies.load('token');
  if (accessToken !== '' && accessToken !== undefined && accessToken !== null) {
    const accessTime = cookies.load('time');
    const curTime = new Date().getTime();

    if (curTime - Number(accessTime) > (config.SESSION_EXPIRATION_TIME - config.SESSION_ALARM_TIME) && !sessionCheck) {
      console.log('sessionCheck: ', sessionCheck);
      sessionCheck = true;
    }

    const timeOut = setTimeout(checkSession, 1000);

    if (sessionCheck && curTime - Number(accessTime) > config.SESSION_EXPIRATION_TIME) {
      // 서버에서 세션 만료 처리
      clearTimeout(timeOut);
    }
  }
}
